<div class="toolbar1">
    <p class="toolbar-text">Select Parameters : {{headername}}</p>
  </div>
  <div class="gridSize" style="overflow-y: scroll;margin-bottom: 15px;" *ngIf="!fromTable">
    <div class="grid-style">
      <div *ngIf="!showScope"
        style="margin-left: 10px; margin-right: 10px; padding-bottom: 10px;">
        <h3 style="font-size: 14px;font-weight:500;margin:0px 0px 5px !important">Business Objects</h3>
        <ng-container *ngFor="let param of dataObj, index as i">
          <div *ngIf="param.name != null" style="margin-left: 10px; margin-right: 30px;">
            <mat-checkbox (click)="onScopeClick(param,i)" [checked]="param.scope" [disableRipple]="true"
              (click)="$event.preventDefault()">
              <span bat-button>{{param.name}}</span>
            </mat-checkbox>
          </div>
        </ng-container>  
      </div>
  
      <div class="scope" *ngIf="showScope">
<!-- selected options -->        
        <div class="grid-style" style="margin-right: 15px">
          <div class="csh-text">
            <div class="headerText">{{scopeName}}</div>
          </div>
          <div class="searchBox">
            <input class="inputBox" type="search" placeholder="Search" [(ngModel)]="searchValueA"
              (input)="searchOnInput($event.target.value,1)">
            <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" aria-hidden="true"
              (click)="search(1,searchValueA)"></i>
          </div>
          <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal"
            *ngIf="s_options?.length==0">
            <div>
              <img alt="image" src="./assets/Not Found.svg">
              <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
            </div>
          </div>
  
          <div class="checkOptions" style="margin-right: 20px;" *ngIf="s_options?.length>0">
            <mat-checkbox type="checkbox" style="cursor: pointer;" name="list" value="h2" disabled="true" (click)="deSelectAll($event)">
              <span style="color:#333333">De-Select all</span>
            </mat-checkbox>
          </div>
          <div *ngIf="s_options?.length!=0">
            <div class="options">
              <mat-checkbox class="example-radio-button" [disableRipple]="true" style="display: block;margin-left: 26px;"
                *ngFor="let data of s_options; let i=index" [checked]="data.checkVal"
                (change)="onOptionsclick($event.checked,i,data)" class="textFormat">
                {{data.businessname}}
              </mat-checkbox>
            </div>
          </div>
        </div>  

<!-- removed options -->
<div class="grid-style">
  <div class="csh-text">
    <div class="headerText">Removed from {{scopeName}}</div>
  </div>
  <div class="searchBox">
    <input class="inputBox" type="search" placeholder="Search" [(ngModel)]="searchValueB"
      (input)="searchOnInput($event.target.value,2)">
    <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" aria-hidden="true"
      (click)="search(2,searchValueB)"></i>
  </div>
  <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal"
    *ngIf="r_options?.length==0">
    <div>
      <img alt="image" src="./assets/Not Found.svg">
      <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
    </div>
  </div>

  <div class="checkOptions" style="margin-right: 20px;" *ngIf="r_options?.length>0">
    <mat-checkbox type="checkbox" style="cursor: pointer;" name="list" value="h1" disabled="true" (click)="selectAll($event)">
      <span style="color:#333333">Select all</span>
    </mat-checkbox>
  </div>
  <div *ngIf="r_options?.length!=0">
    <div class="options">
      <mat-checkbox class="example-radio-button" [disableRipple]="true" style="display: block;margin-left: 26px;"
        *ngFor="let data of r_options; let i=index" [checked]="data.checkVal" 
        (change)="onOptionsclick($event.checked,i,data)" class="textFormat">
        {{data.businessname}}
      </mat-checkbox>
    </div>
  </div>
</div> 


      </div>
    </div>
  </div>
  
  <div  class="gridSize" style="overflow-y: scroll;margin-bottom: 15px;" *ngIf="fromTable">
    <div class="grid-style"> 
      <div *ngIf="!showScope"
        style="margin-left: 10px; margin-right: 10px; padding-bottom: 10px;">
        <h3 style="font-size: 14px;font-weight:500;margin:0px 0px 5px !important">Business Objects</h3>
        <ng-container *ngFor="let param of dataObj, index as i">
          <div *ngIf="param.name != null" style="margin-left: 10px; margin-right: 30px;">
            <mat-checkbox (click)="onScopeClickEdit(param,i)" [checked]="param.scope" [disableRipple]="true"
              (click)="$event.preventDefault()">
              <span bat-button>{{param.name}}</span>
            </mat-checkbox>
          </div>
        </ng-container>  
      </div>
  
      <div class="scope" *ngIf="showScope">
<!-- selected options -->
        <div class="grid-style" style="margin-right: 15px">
          <div class="csh-text">
            <div class="headerText">{{scopeName}}</div>
          </div>
          <div class="searchBox">
            <input class="inputBox" type="search" placeholder="Search" [(ngModel)]="searchValueA"
              (input)="searchOnInput($event.target.value,1)">
            <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" aria-hidden="true"
              (click)="search(1,searchValueA)"></i>
          </div>
  
          <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal"
            *ngIf="s_options?.length==0">
            <div>
              <img alt="image" src="./assets/Not Found.svg">
              <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
            </div>
          </div>
  
          <div class="checkOptions" style="margin-right: 20px;"
            *ngIf="s_options?.length>0">
        
            <mat-checkbox type="checkbox" style="cursor: pointer;" name="list_name" value="h2" disabled="true" (click)="deSelectAll($event)">
              <span style="color:#333333">De-Select all</span>
            </mat-checkbox>
          </div>
          <div *ngIf="s_options?.length!=0">
            <div class="options">
              <mat-checkbox class="example-radio-button" [disableRipple]="true" style="display: block;margin-left: 26px;"
                *ngFor="let data of s_options; let i=index" [checked]="data.checkVal"
                (change)="onOptionsclick($event.checked,i,data)" class="textFormat">
                {{data.businessname}}
              </mat-checkbox>
            </div>
          </div>
        </div>  

<!-- removed options -->
        <div class="grid-style">
          <div class="csh-text">
            <div class="headerText">Removed from {{scopeName}}</div>
          </div>
          <div class="searchBox">
            <input class="inputBox" type="search" placeholder="Search" [(ngModel)]="searchValueB"
              (input)="searchOnInput($event.target.value,2)">
            <i class="fa fa-search" style="color:rgba(0,0,0,.87); cursor:pointer;" aria-hidden="true"
              (click)="search(2,searchValueB)"></i>
          </div>
  
          <div class="checkOptions" style="text-align: center; margin-top: 100px; font-weight: normal"
            *ngIf="r_options?.length==0">
            <div>
              <img alt="image" src="./assets/Not Found.svg">
              <p style="font-size: 26px;color: #333333; margin-top: 10px;">No Items!</p>
            </div>
          </div>
  
          <div class="checkOptions" style="margin-right: 20px;"
            *ngIf="r_options?.length>0">
            <mat-checkbox type="checkbox" style="cursor: pointer;" name="list_name" value="h1" disabled="true" (click)="selectAll($event)">
              <span style="color:#333333">Select all</span>
            </mat-checkbox>

          </div>
          <div *ngIf="r_options?.length!=0">
            <div class="options">
              <mat-checkbox class="example-radio-button" [disableRipple]="true" style="display: block;margin-left: 26px;"
                *ngFor="let data of r_options; let i=index" [checked]="data.checkVal"
                (change)="onOptionsclick($event.checked,i,data)" class="textFormat">
                {{data.businessname}}
              </mat-checkbox>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </div>



  <div class="" style="padding-left: 15px; ">
    <button mat-flat-button class="cancelButton r-m12" (click)="onCancel()"> Cancel</button>
    
    <button *ngIf="!showScope" mat-flat-button class="green-button l-m12" style="margin-right: 15px;" [disabled]="showScope && s_options?.length!=0" (click)="saveOptions()"> Save Parameters </button>
    <button *ngIf="showScope"  mat-flat-button class="green-button l-m12" style="margin-right: 15px;" (click)="add()" > ADD </button>
  </div>
  
